import { render, staticRenderFns } from "./Step_6.vue?vue&type=template&id=71525797&scoped=true&"
import script from "./Step_6.vue?vue&type=script&lang=ts&"
export * from "./Step_6.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71525797",
  null
  
)

export default component.exports